import React from 'react';

class SDGTableTHead extends React.PureComponent {
  renderTHList(data) {
    return data.map((item, index) => {
      return (
        <th colSpan={ item.colspan } key={ index }>
          { item.text }
        </th>
      )
    });
  }

  renderTRList() {
    const data = this.props.data;

    return data.map((item, index) => {
      const className = (index === 0) ? 'bg-primary center-row sdg-table__header': '';

      return (
        <tr key={ index } className={ className }>
          { this.renderTHList(item) }
        </tr>
      );
    });
  }

  render() {
    return (
      <thead>
        { this.renderTRList() }
      </thead>
    )
  }
}

export default SDGTableTHead;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGTableTHead.js